export const purchaseReportsColumn = [
    {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Invoice No',
        accessor: 'invoiceNo',
      },
      {
        Header: 'Supplier Name',
        accessor: 'supplierName',
      },
      {
        Header: 'Amount',
        accessor: 'amount',
      },
]

export const purchaseReportsTableData = [
    {   
        date:'28/04/2022',
        invoiceNo:'252561',
        supplierName:'Jerry',
        amount: '$1500',
    },
    {   
        date:'18/05/2022',
        invoiceNo:'252562',
        supplierName:'Lord',
        amount: '$1900',
    },
    {   
        date:'08/05/2023',
        invoiceNo:'252563',
        supplierName:'Mordy',
        amount: '$1100',
    },
    {   
        date:'08/11/2024',
        invoiceNo:'252576',
        supplierName:'Samantha',
        amount: '$2500',
    },
    {   
        date:'18/05/2022',
        invoiceNo:'252562',
        supplierName:'Lord',
        amount: '$1900',
    },
    {   
        date:'18/12/2024',
        invoiceNo:'252578',
        supplierName:'Amanda',
        amount: '$2700',
    },
    {   
      date:'19/12/2024',
      invoiceNo:'252579',
      supplierName:'Olivia',
      amount: '$1850',
    },
    {   
      date:'28/04/2022',
      invoiceNo:'252561',
      supplierName:'Jerry',
      amount: '$1500',
    },
]